<template>
  <div>
    <p v-if="showTitle" class="title">Memory</p>
    <vue-c3 :handler="chart"></vue-c3>
  </div>
</template>

<script>
import Vue from "vue";
import VueC3 from "vue-c3";

export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      memUsage: 0,
      chart: new Vue()
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  mounted() {
    this.initGraph();
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "memory.php")
        .then(response => {
          if (this.memUsage != response.data.value) {
            this.memUsage = response.data.value;
            this.updateGraph();
            this.$emit("valueChanged", this.memUsage + "%");
          }
          setTimeout(() => {
            this.startMonitor();
          }, 5000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    },
    initGraph() {
      const options = {
        data: {
          type: "gauge",
          columns: [["usage", 0]]
        },
        color: {
          pattern: ["#3daee9", "#fdbc4b", "#c0392b"],
          threshold: {
            values: [40, 70, 100]
          }
        },
        tooltip: {
          show: false
        },
        legend: {
          hide: true
        },
        gauge: {
          label: {
            show: false
          }
        }
      };
      this.chart.$emit("init", options);
    },
    updateGraph() {
      let options = {
        columns: [["usage", this.memUsage]]
      };
      this.chart.$emit("dispatch", cart => cart.load(options));
    }
  },
  components: {
    VueC3
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorMemory.vue